import axios from 'axios'

/**
 * Nature des echecs de requete, pour decider si la carte doit afficher une
 * panne ou simplement ne rien montrer.
 *
 * Deux cas passent pour des erreurs sans en etre :
 *
 *  - l'ANNULATION. Changer de culture ou d'annee annule tout ce qui est en vol
 *    (`cancelAllRequests`), et les promesses en cours partent en rejet. Ce
 *    n'est pas une panne : c'est l'utilisateur qui a change d'ecran.
 *  - le 404, sur les cartes de cloture. Le serveur repond 404 quand l'adherent
 *    n'a pas de synthese sur l'annee ; la carte retombe alors sur son message
 *    d'invitation.
 */

/**
 * Indique si l'echec vient d'une annulation de la requete.
 *
 * @param {*} erreur rejet de la promesse
 * @returns {boolean} vrai si la requete a ete annulee
 */
export function isRequeteAnnulee (erreur) {
  return axios.isCancel(erreur) || erreur?.code === 'ERR_CANCELED'
}

/**
 * Indique si l'echec merite le message "Le service est momentanement
 * indisponible".
 *
 * Une annulation et un 404 n'en sont pas. Tout le reste, oui - y compris un
 * rejet sans objet d'erreur, qui reste un echec dont on ne sait rien.
 *
 * @param {*} erreur rejet de la promesse
 * @returns {boolean} vrai s'il faut afficher le message de panne
 */
export function isPanneServeur (erreur) {
  return !isRequeteAnnulee(erreur) && erreur?.status !== 404
}
